// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-upload {
  background-color: rgba(0, 0, 0, 0.1);
}
.file-upload mat-icon {
  line-height: 30px;
}
.file-upload .clear {
  float: right;
}
.file-upload span {
  vertical-align: text-bottom;
  margin-left: 10px;
  font-size: 13px;
}`, "",{"version":3,"sources":["webpack://./src/app/framework/file-upload/file-upload.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/framework/file-upload/file-upload.component.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;ACCJ;ADAI;EACI,iBAAA;ACER;ADAI;EACI,YAAA;ACER;ADAI;EACI,2BAAA;EACA,iBAAA;EACA,eAAA;ACER","sourcesContent":[".file-upload {\n    background-color: rgba(0,0,0, 0.1);\n    mat-icon {\n        line-height: 30px;\n    }\n    .clear {\n        float: right;\n    }\n    span {\n        vertical-align: text-bottom;\n        margin-left: 10px;\n        font-size: 13px;\n    }\n}",".file-upload {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.file-upload mat-icon {\n  line-height: 30px;\n}\n.file-upload .clear {\n  float: right;\n}\n.file-upload span {\n  vertical-align: text-bottom;\n  margin-left: 10px;\n  font-size: 13px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
